import { render, staticRenderFns } from "./AddToCartSuccess.vue?vue&type=template&id=20abe5d2"
import script from "./AddToCartSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddToCartSuccess.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddToCartSuccess.vue?vue&type=style&index=0&id=20abe5d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports